import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router doesn't reset scroll position on navigation the way a real
// page load does -- clicking from a long use-case page to a new one (or to
// Home) leaves you scrolled halfway down the new page. This just scrolls
// back to the top whenever the URL path changes. Renders nothing; drop it
// inside <BrowserRouter> once.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
